import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTypesShinkansen = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M31.9836 24.7782H28.8174L3 24.7782C1.34314 24.7782 0 23.4351 0 21.7782V12.7731C0 11.1164 1.34295 9.77329 2.99967 9.77311L15.7587 9.77173C19.8187 9.77173 23.8804 10.7181 27.5111 12.5187C30.2127 13.8382 32.6812 15.6201 34.8278 17.8026C34.8999 17.8742 34.972 17.9561 35.0341 18.0294C35.6596 18.7763 36 19.7209 36 20.6945C36 21.7858 35.5874 22.8037 34.8278 23.5864C34.058 24.3503 33.0485 24.7782 31.9836 24.7782Z",
			fill: "url(#paint0_linear_10904_6280)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.0036 17.9579C17.6436 17.9579 16.5435 16.8393 16.5435 15.4565C16.5435 14.7932 16.8034 14.1657 17.2679 13.6917C17.7324 13.2194 18.3496 12.9551 19.0036 12.9551H22.8449H25.9841C26.4459 12.9551 26.9027 13.0593 27.3115 13.2741C27.7416 13.5001 28.1664 13.737 28.5828 13.9833C28.6985 14.0566 28.8159 14.1384 28.9316 14.2101C29.4331 14.5187 29.9328 14.8375 30.4074 15.1837C30.622 15.3389 30.8283 15.5111 31.043 15.6748C31.4102 15.9561 31.7859 16.2392 32.1347 16.5393C32.3578 16.7302 32.5724 16.9485 32.7971 17.148C33.1207 17.4461 32.9152 17.9579 32.4752 17.9579L26.3297 17.9579L19.0036 17.9579Z",
			fill: "url(#paint1_linear_10904_6280)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.619629 26.2283H32.4667",
			stroke: "#0393F4",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -4.12576,
			y: 7.61154,
			width: 15.6046,
			height: 15.69,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(2.67px)",
					clipPath: "url(#bgblur_0_10904_6280_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			"data-figma-bg-blur-radius": 5.34354,
			x: 1.21777,
			y: 12.9551,
			width: 4.91755,
			height: 5.00284,
			rx: 1,
			fill: "white",
			fillOpacity: .77
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 1.85031,
			y: 7.61154,
			width: 15.6046,
			height: 15.69,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(2.67px)",
					clipPath: "url(#bgblur_1_10904_6280_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			"data-figma-bg-blur-radius": 5.34354,
			x: 7.19385,
			y: 12.9551,
			width: 4.91755,
			height: 5.00284,
			rx: 1,
			fill: "white",
			fillOpacity: .77
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_10904_6280_clip_path",
				transform: "translate(4.12576 -7.61154)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 1.21777,
					y: 12.9551,
					width: 4.91755,
					height: 5.00284,
					rx: 1
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_1_10904_6280_clip_path",
				transform: "translate(-1.85031 -7.61154)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 7.19385,
					y: 12.9551,
					width: 4.91755,
					height: 5.00284,
					rx: 1
				})
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_10904_6280",
				x1: 14.0623,
				y1: 9.77173,
				x2: 17.0181,
				y2: 26.7971,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#53B1F1" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0393F4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_10904_6280",
				x1: 16.5435,
				y1: 15.4565,
				x2: 33.6558,
				y2: 15.4565,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C2E7FF" }), /* @__PURE__ */ _jsx("stop", {
					offset: .600962,
					stopColor: "white"
				})]
			})
		] })
	]
});
export default SvgTypesShinkansen;
